import React, { useState, useEffect, useCallback } from "react";
import TreeMap, { Tooltip } from 'devextreme-react/tree-map';
import TagBox from 'devextreme-react/tag-box';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import ArrayStore from 'devextreme/data/array_store';
import axios from "axios";
import routes from "../../../assets/apiRoutes.json";
import { connect } from "react-redux";
import { LoadIndicator } from "devextreme-react/load-indicator";

import {
  Column,
  DataGrid,
  GroupPanel,
  Grouping,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  LoadPanel,
  ColumnHeaderFilter,
  FilterRow,
  Export
} from "devextreme-react/data-grid";
import { TextBox } from "devextreme-react";

const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
const warehouseTagBox = React.createRef();
const locationFilterTextBox = React.createRef();
const treeMap = React.createRef();
var totalSelectedWarehouses = 0;
var totalLoadedWarehouses = 0;

const customizeTooltip = (arg) => {
  const { data } = arg.node;
  return {
    text: arg.node.isLeaf()
      ? `<span style="font-weight: 500;">${data.warehouse}-${data.name}</span><br/>Available Quantity: ${data.available}`
      : null,
  };
};

const WarehouseMap = (props) => {
  var accessToken = props.oidc.user.access_token;
  const [popupState, setPopUpState] = useState(false);
  const [noDataText, setNoDataText] = useState("Loading Data ...");
  const [warehouseData, setWarehouseData] = useState([]);
  const [inventoryData, setInventoryData] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [loadIndicatorVisible, setLoadIndicatorVisible] = useState(true);


  const nodeClick = (e) => {
    if (e.node.data.locationrowid != "00000000-0000-0000-0000-000000000000") {
      setLoadIndicatorVisible(true);
      var locationArray = new Array();
      var location = new Object();
      location.Warehouse = e.node.data.warehouse;
      location.Location = e.node.data.name;
      locationArray.push(location);
      setLocationData(locationArray);
      setInventoryData([]);
      setNoDataText("Loading Data ...");
      setPopUpState(true);

      axios
        .get(`${window._env_.REACT_APP_APIS}/${routes.WarehouseMap.GetLocationInventory}?locationRowId=${e.node.data.locationrowid}`,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`,
            },
          })
        .then((res) => {
          setLoadIndicatorVisible(false);
          setInventoryData(res.data);
          if (res.data.length == 0) {
            setNoDataText("No Data");
          }
        });
    }
  };

  const treeDrawn = (e) => {
    totalLoadedWarehouses = totalLoadedWarehouses + 1;
    if (totalLoadedWarehouses == totalSelectedWarehouses) {
      setLoadIndicatorVisible(false);
    }
  };


  const onWarehouseChange = (e) => {
    setLoadIndicatorVisible(true);
    var request = new Object();
    request.keys = e.value;
    request.locationFilter = locationFilterTextBox.current.instance().option("value");

    axios.post(
      `${window._env_.REACT_APP_APIS}/${routes.WarehouseMap.GetWarehouseMapData}`,
      request,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken,
        },
      }
    ).then((response) => {

      totalSelectedWarehouses = e.value.length;
      totalLoadedWarehouses = 0;
      setWarehouseData(response.data);
      if (response.data.length == 0) {
        setLoadIndicatorVisible(false);
      }

    })
      .catch((err) => {
        alert(err, "Error");
      });
  }

  const onLocationFilterChange = (e) => {
    setLoadIndicatorVisible(true);

    var request = new Object();
    request.keys = warehouseTagBox.current.instance().option("value");
    request.locationFilter = e.value;

    axios.post(
      `${window._env_.REACT_APP_APIS}/${routes.WarehouseMap.GetWarehouseMapData}`,
      request,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken,
        },
      }
    ).then((response) => {

      totalSelectedWarehouses = request.keys.length;
      totalLoadedWarehouses = 0;
      setWarehouseData(response.data);
      if (response.data.length == 0) {
        setLoadIndicatorVisible(false);
      }

    })
      .catch((err) => {
        setLoadIndicatorVisible(false);
        alert(err, "Error");
      });
  }

  useEffect(() => {

    setLoadIndicatorVisible(true);
    axios.get(`${window._env_.REACT_APP_APIS}/${routes.WarehouseMap.GetWarehouses}`,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
      .then((response) => {
        warehouseTagBox.current.instance().option(
          "dataSource",
          new ArrayStore({
            data: response.data.data,
            key: 'id'
          })
        );

        var valuesArray = new Array();
        for (let index = 0; index < response.data.selectedkeys.length; index++) {
          valuesArray.push(response.data.selectedkeys[index]);
        }

        totalSelectedWarehouses = valuesArray.length;
        totalLoadedWarehouses = 0;

        if (valuesArray.length == 0) {
          setLoadIndicatorVisible(false);
        }
        else {
          warehouseTagBox.current.instance().option(
            "value",
            valuesArray
          );
        }

      })
      .catch((err) => {
        setLoadIndicatorVisible(false);
        console.log(err, "Error in loading warehouses");
      });
  }, []);

  return (
    <div>
      <div>
        <Toolbar>
          <Item location="before" >
          <h6
                          style={{
                            color: window._env_.Color2,
                            margin:'15px'
                          }}
                        >
                          Warehouse Map
                        </h6>
          </Item>
          <Item location="after">
            <LoadIndicator
              style={{
                height: "20px",
                width: "20px",
                verticalAlign: "middle",
                marginRight: "5px",
              }}
              visible={loadIndicatorVisible}
            />
          </Item>
          <Item location="after">
            <TagBox
              stylingMode='outlined'
              labelMode="static"
              ref={warehouseTagBox}
              width={500}
              maxDisplayedTags={5}
              maxFilterQueryLength={Infinity}
              displayExpr="name"
              valueExpr="id"
              showSelectionControls={true}
              applyValueMode="useButtons"
              placeholder="Select Warehouses"
              onValueChanged={onWarehouseChange}
              multiline={false}
            />
          </Item>
          <Item location="after">
            <TextBox
              stylingMode='outlined'
              labelMode="static"
              ref={locationFilterTextBox}
              width={200}
              placeholder="Location Filter"
              onValueChanged={onLocationFilterChange}
              style={{ marginRight: "15px" }}
            />
          </Item>
        </Toolbar>
      </div>
      {warehouseData.map((m, i) => (
        <TreeMap
          key={i}
          dataSource={[m]}
          style={{ backgroundColor: "white", height: m.items.length <= 50 ? "120px" : m.items.length <= 100 ? "240px" : m.items.length <= 250 ? "600px" : m.items.length <= 350 ? "840px" : "1200px" }}
          onClick={nodeClick}
          onDrawn={treeDrawn}>
          <Tooltip
            enabled={true}
            format="thousands"
            customizeTooltip={customizeTooltip}
          />

        </TreeMap>
      ))}
      <Popup
        visible={popupState}
        onHiding={() => {
          setPopUpState(false);
        }}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={true}
        showTitle={true}
        title="Inventory"
        container="#root"
        width={950}
        height={650}
      >
        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
          showBorders={true}
          dataSource={locationData}
        >
          <Column dataField="Warehouse" caption="Warehouse"></Column>
          <Column dataField="Location" caption="Location"></Column>
        </DataGrid>
        <div className="row">
          <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            noDataText={noDataText}
            dataSource={inventoryData}
            showBorders={true}
            height={460}
            className="customDataTableDesign"
            hoverStateEnabled={true}
            allowColumnResizing={true}
            allowColumnReordering={true}
          >
            <ColumnHeaderFilter />
            <LoadPanel enabled={true} />
            <Paging enabled={true} />
            <Pager
              visible={true}
              showPageSizeSelector={true}
              allowedPageSizes={allowedPageSizes}
              showNavigationButtons={true}
              showInfo={true} />
            <FilterRow visible={true} />
            <FilterPanel visible={true} />
            <GroupPanel visible={false} />
            <Grouping autoExpandAll={false} />
            <Export enabled={true} allowExportSelectedData={true} text="Export" />
            <Sorting mode="multiple" />
            <Column dataField="customer" caption="Customer"></Column>
            <Column dataField="itemCode" caption="Item">
            </Column>
            <Column dataField="lotCode" caption="Lot"></Column>
            <Column dataField="subLotCode" caption="Sublot"></Column>
            <Column dataField="available" caption="Available"></Column>
          </DataGrid>
        </div>
      </Popup>
    </div>

  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(WarehouseMap);
